import { request } from "../../api";

/** Proposed admin-only contract; a 404/405/501 is rendered as unavailable. */
export interface ViolationDeduplicationSettings {
  enabled: boolean;
  /** Job cadence, not raw retention or a window for collapsing distinct attempts. */
  interval_hours: number;
  last_run_at: string | null;
  next_run_at: string | null;
  last_status: "idle" | "queued" | "running" | "succeeded" | "failed";
  last_merged_rows?: number | null;
}

export interface ViolationDeduplicationRun {
  run_id: string;
  status: "queued" | "running" | "succeeded";
}

const base = "/api/admin/v1/monitoring/violations/deduplication/";

export const violationMaintenanceApi = {
  get: () => request<ViolationDeduplicationSettings>(base),
  update: (enabled: boolean) => request<ViolationDeduplicationSettings>(base, {
    method: "PATCH", json: { enabled, interval_hours: 48 },
  }),
  run: () => request<ViolationDeduplicationRun>(`${base}run/`, { method: "POST", json: {} }),
};
